import { render } from "./arrow.vue?vue&type=template&id=50a49655"
import script from "./arrow.vue?vue&type=script&lang=js"
export * from "./arrow.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./arrow.vue?vue&type=style&index=0&id=50a49655&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__